import { createTheme } from '@mui/material'

export const DefaultTheme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#b71c1c',
    },
    secondary: {
      main: '#ffffff',
    },
    // Custom colors for specific purposes.
    social: {
      facebook: "#1674ea",
    },
    // Static colors references.
    black: {
      main: "#000000",
    },
    white: {
      main: "#ffffff",
    },
  },
});
